'use client';

import { cn } from '@shared/shared-utils';
import { Button } from '../../../../../../../../libs/components/components';
import { ReactNode, useState } from 'react';
import { StaticImageData } from 'next/image';
import ExportedImage from 'next-image-export-optimizer';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';
import { Dialog, DialogContent, DialogTrigger } from '@shared/shared-shadcn-ui';
import { GetHealingHelpBanner } from '../get-healing-help-banner/get-healing-help-banner';

type Properties = {
  label: ReactNode;
  buttonLabel: string;
  className?: string;
  buttonClassName?: string;
  image: string | StaticImageData;
  videoSrc: string;
};

const HighlightCard = ({
  label,
  buttonLabel,
  className,
  buttonClassName,
  image,
  videoSrc,
}: Properties) => {
  const [isPaused, setIsPaused] = useState<boolean>(true);

  return (
    <Dialog>
      <div
        className={cn(
          'flex flex-col lg:flex-row bg-ogn-blue rounded-[8px] w-full h-full  ',
          className,
        )}
      >
        <div className="flex lg:contents">
          <div className="flex items-center justify-center rounded-l-[8px] w-auto max-w-[140px] h-full flex-shrink-0 overflow-hidden">
            <ExportedImage
              src={image}
              alt=""
              width={140}
              height={220}
              className="object-cover w-full h-full min-h-[220px]"
            />
          </div>
          <div className="p-6 lg:p-11 flex flex-col justify-center lg:justify-between rounded-r-[8px] lg:rounded-r-[8px] flex-1 lg:gap-y-8">
            <div className="text-[22px] xl:text-[min(1.5vw,24px)] text-ogn-white font-bold">
              {label}
            </div>
            <DialogTrigger asChild>
              <Button
                variant="white"
                className={cn(
                  'hidden lg:flex self-start lg:self-end text-[32px] gap-x-2 items-center',
                  buttonClassName,
                )}
                size="sm"
              >
                {buttonLabel}
                <ArrowRightIcon className="w-4 h-4" />
              </Button>
            </DialogTrigger>
          </div>
        </div>
        <DialogTrigger asChild>
          <Button
            variant="white"
            className={cn(
              'lg:hidden text-[32px] mt-12 mb-10 mx-6 flex gap-x-2 items-center justify-center',
              buttonClassName,
            )}
            size="sm"
          >
            {buttonLabel}
            <ArrowRightIcon className="w-4 h-4" />
          </Button>
        </DialogTrigger>
      </div>

      <DialogContent
        forceMount
        className="w-[90vw] lg:w-[80vw] bg-white max-w-[1370px] p-0"
      >
        <div className="relative w-full h-full">
          <video
            src={videoSrc}
            className="w-full h-full"
            preload="auto"
            autoPlay
            controls
            onPause={() => setIsPaused(true)}
            onPlay={() => setIsPaused(false)}
          />
          {isPaused && <GetHealingHelpBanner />}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { HighlightCard };
